import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';

const VideoErrorLogProvider = (props) => {
  const api = new API();
  const [videoErrorLogList, setVideoErrorLogList] = useState([]);
  const [videoErrorLogListLoader, setVideoErrorLogListLoader] = useState(false);
  const [videoErrorLogListPagination, setVideoErrorLogListPagination] = useState({
    page: 1,
    limit: 10,
    total: 0
  });

  const fetchVideoErrorLogList = async (data) => {
    setVideoErrorLogListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("videoerrorlog", {
        page: data?.page || videoErrorLogListPagination.page,
        limit: data?.limit || videoErrorLogListPagination.limit,
        name: data?.name || ""
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoErrorLogList(res?.data?.data?.data || []);
          setVideoErrorLogListPagination({
            page: res?.data?.data?.pagination?.page || 1,
            limit: res?.data?.data?.pagination?.limit || 10,
            total: res?.data?.data?.pagination?.total || 0
          });
        } else {
          setVideoErrorLogList([]);
        }
        setVideoErrorLogListLoader(false);
      }));
  }

  return (
    <Context.Provider value={{
      ...props,
      videoErrorLogList,
      videoErrorLogListLoader,
      videoErrorLogListPagination,
      fetchVideoErrorLogList
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default VideoErrorLogProvider;
